module.exports = __webpack_public_path__ + "static/media/23-iveco.ec938498.jpg";